/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";
import Card from "./card.component";
import Modal from "./modal/modal.component";
import DataTable from "react-data-table-component";
import connect from "../views/axios/axios.auth";
import {
  faCheck,
  faSearch,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RecipientAddressEdit } from "./destinatarioEditTable/addressEditable";
import { ConfigContextUtils } from "../context/contextUtils.context";
import notification from "./notification.component";

const DireccionesModal = ({
  clienteId = null,
  onSelect,
  paises = [],
  estados = [],
}) => {
  const { setPreloader } = useContext(ConfigContextUtils);
  const [visible, setVisible] = useState(false);
  const [listado, setListado] = useState([]);
  const [recipientDelete, setRecipientDelete] = useState(null);
  const [currentDataEdit, setCurrentDataEdit] = useState(null);

  const editActive = (row) => {
    setCurrentDataEdit(row);
  };

  const columnsClientes = [
    {
      name: "Direcciones usadas",
      selector: "cliente_receptor_direccion_entrega",
      sortable: true,
      width: "45%",
      wrap: true,
    },
    {
      name: "País",
      selector: (row) => row.recipient_pais.country,
      sortable: true,
      width: "10%",
      wrap: true,
    },
    {
      name: "Estado",
      selector: (row) =>
        row.recipient_estado ? row.recipient_estado.estado : "-",
      sortable: true,
      width: "10%",
      wrap: true,
    },
    {
      name: "Ciudad",
      selector: (row) =>
        row.recipient_ciudad ? row.recipient_ciudad.ciudad : "-",
      sortable: true,
      width: "10%",
      wrap: true,
    },
    {
      name: "",
      center: true,
      cell: (row) => {
        return row.last_use ? (
          <span className="badge badge-success">ÚLTIMO USADO</span>
        ) : null;
      },
    },
    {
      name: "Seleccionar",
      grow: 0,
      right: true,
      cell: (row, index) => (
        <>
          <button
            onClick={() => selected(row)}
            type="button"
            className="btnx btnx-warn m-1"
            disabled={!clienteId}
          >
            <FontAwesomeIcon icon={faCheck} />
          </button>
          {/* <button 
                    onClick={() => editActive(row)}
                    type="button"
                    className="btnx btnx-warn mr-1"
                    disabled={row.editable}
                  >
                        <FontAwesomeIcon icon={faEdit} />
                </button> */}
          <button
            onClick={() => deleteRecipient({ ...row, index })}
            type="button"
            className="btnx btnx-warn"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };

  const listadoObtenidos = () => {
    connect.post(`/guias/direcciones`, { clienteId }).then((response) => {
      if (response.data.direcciones.length) {
        response.data.direcciones[0].last_use = true;
      }
      console.log("response.data.direcciones", response.data.direcciones);
      setListado(response.data.direcciones);
    });
  };

  useEffect(() => {
    if (visible) {
      listadoObtenidos();
    }
  }, [visible]);

  const selected = (row) => {
    onSelect(row);
    setVisible(false);
  };

  const deleteRecipient = (row) => {
    setRecipientDelete(row);
  };

  const confirmDelete = () => {
    setPreloader(true);
    connect
      .post("/cliente/direccion-remove/", {
        recipient_address_id: recipientDelete.id,
      })
      .then((response) => {
        if (response.data.error) {
          notification.warning(response.data.message);
        } else {
          notification.success(response.data.message);
          const uListado = [...listado];
          const fIndex = uListado.findIndex(
            ({ id }) => id === recipientDelete.id
          );
          uListado.splice(fIndex, 1);
          setListado(uListado);
          setRecipientDelete(null);
        }
        setPreloader(false);
      });
  };

  const updateData = () => {
    setCurrentDataEdit(null);
    listadoObtenidos();
  };

  const cleandata = () => {
    setCurrentDataEdit(null);
  };

  const getColor = () => {
    let value = -1;
    if (recipientDelete) {
      value = recipientDelete.id;
    }

    return value;
  };

  const conditionalRowBoleta = [
    {
      when: (row) => row.id === getColor(),
      style: {
        backgroundColor: "rgba(255, 127, 127, 0.9)",
        color: "black",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  return (
    <>
      <button
        onClick={() => setVisible(true)}
        type="button"
        className="btnx btnx-warn mr-1"
        disabled={!clienteId}
      >
        <FontAwesomeIcon icon={faSearch} /> Direcciones
      </button>
      <Modal show={visible} size="xl">
        <Card>
          {currentDataEdit !== null ? (
            <div className="disabled-modal"></div>
          ) : null}
          <DataTable
            title="Direcciones"
            customStyles={customStyles}
            columns={columnsClientes}
            data={listado}
            dense={true}
            pagination={true}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5]}
            conditionalRowStyles={conditionalRowBoleta}
            noDataComponent={
              <div className="m-3">
                Este cliente no tiene direcciones anteriores.
              </div>
            }
          />
          <div className="d-flex justify-content-between">
            <button
              onClick={() => setVisible(false)}
              type="button"
              className="btnx btnx-warn mr-1"
            >
              Cerrar
            </button>
            {recipientDelete !== null ? (
              <div>
                <button
                  onClick={() => setRecipientDelete(null)}
                  type="button"
                  className="btnx btnx-warn mr-1"
                >
                  Cancelar
                </button>
                <button
                  onClick={confirmDelete}
                  type="button"
                  className="btnx btnx-warn mr-1"
                  style={{ backgroundColor: "#FC2D2D" }}
                >
                  {`Confirmar eliminar esta dirección`}
                </button>
              </div>
            ) : null}
          </div>
        </Card>
      </Modal>
      <RecipientAddressEdit
        data={currentDataEdit}
        onUpdate={updateData}
        onClose={cleandata}
        paises={paises}
        estados={estados}
      />
    </>
  );
};

export default DireccionesModal;
